import React from 'react';

import DataTableButtonsFunction from "./datatable-buttons-function";
import DataTableHeader from "./datatable-content";
import DataTablePagination from "./datatable-pagination";

export default function DataTableSarang(props) {
    const {
        listData,
        // button functions
        rowsPerPage,
        handleChangeRowsPerPage,
        // head cells
        headCells,
        handleRequestSort,
        // footer pagination
        totalItemCount,
        pageIndex,
        handleChangePage,
        order,
        orderBy,
        // children
        children,
        sumary,
        configLocal,
        getList,
        getSumary,
        searchData,
        hideButtons,
        customButtons
    } = props;

    return (
        <div className="card">
            <div className="card-body">
                <DataTableButtonsFunction
                    rowsPerPage={rowsPerPage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    sumary={sumary}
                    configLocal={configLocal}
                    getList={getList}
                    getSumary={getSumary}
                    searchData={searchData}
                    hideButtons={hideButtons}
                    customButtons={customButtons}
                />
                <DataTableHeader
                    headCells={headCells}
                    handleRequestSort={handleRequestSort}
                    order={order}
                    orderBy={orderBy}
                    listData={listData}
                    totalItemCount={totalItemCount}
                >
                    {children}
                </DataTableHeader>
                {
                    totalItemCount > 0 ?
                        <DataTablePagination
                            totalItemCount={totalItemCount}
                            rowsPerPage={rowsPerPage}
                            pageIndex={pageIndex + 1}
                            handleChangePage={handleChangePage}
                        /> :
                        <></>
                }
            </div>
        </div>
    )
}